export default __webpack_public_path__ + "static/media/downloadtop_blue.17145c26.svg";